import {mapActions, mapState} from "vuex";

export const productionMixins = {
    computed: {
        ...mapState("user", ["permissionCode"])
    },
    data() {
        return {
            formData: {
                id: null,
                allowable: 0,
                category: 0,
                type: 0,
                description: "",
                imageList: [],
                introduce: {
                    audioSsmlText: "",
                    audioText: "",
                    voice: "zhiyuan",
                    speechRate: 1.0,
                    materialId: null,
                    materialUrl: "",
                    filename: "",
                },
                discount: null,
                groupPurchase: false,
                groupPurchaseDataList: [
                    {
                        expiredTime: 86400000,
                        groupSize: null,
                        id: null,
                        productId: null,
                        salePrice: null,
                    },
                ],
                name: "",
                nicknames: [],
                paymentMethod: 1,
                materialUrl: "",
                productSubjects: [],
                salePrice: null,
                commercial: null,
                buyOutPrice: null,
                tagValueIdList: [],
                text: "",
                total: null,
                validityType: 0,
            },
            form: {
                id: null,
                allowable: 0,
                category: 0,
                type: 0,
                description: "",
                imageList: [],
                introduce: {
                    audioSsmlText: "",
                    audioText: "",
                    voice: "zhiyuan",
                    speechRate: 1.0,
                    materialId: null,
                    materialUrl: "",
                    filename: "",
                },
                discount: null,
                groupPurchase: false,
                groupPurchaseDataList: [
                    {
                        expiredTime: 43200000,
                        groupSize: null,
                        id: null,
                        productId: null,
                        salePrice: null,
                    },
                ],
                name: "",
                nicknames: [],
                paymentMethod: 0,
                materialUrl: "",
                productSubjects: [],
                salePrice: null,
                commercial: null,
                buyOutPrice: null,
                tagValueIdList: [],
                text: "",
                total: null,
                validityType: 0,
            },
            options: [],
            rules: {
                category: [
                    {
                        required: true,
                        message: "请选择",
                        trigger: ["blur", "change"],
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "请输入",
                        trigger: ["blur", "change"],
                    },
                ],
                nicknames: [
                    {
                        required: true,
                        message: "至少输入一位主讲老师",
                        trigger: ["blur", "change"],
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value.length === 0) {
                                callback(new Error("至少输入一位主讲老师"));
                            } else {
                                callback();
                            }
                        },
                        trigger: ["blur", "change"],
                    },
                ],
                text: [
                    {
                        required: true,
                        message: "请输入",
                        trigger: ["blur", "change"],
                    },
                ],
                materialUrl: [
                    {
                        required: true,
                        message: "请选择",
                        trigger: ["blur", "change"],
                    },
                ],
                paymentMethod: [
                    {
                        required: true,
                        message: "请选择",
                        trigger: ["blur", "change"],
                    },
                ],
                salePrice: [
                    {
                        required: true,
                        message: "请输入",
                        trigger: ["blur", "change"],
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (isNaN(value) || value <= 0) {
                                callback(new Error("销售价必须大于0元"));
                            } else {
                                callback();
                            }
                        },
                        trigger: ["blur", "change"],
                    },
                ],
                validityType: [
                    {
                        required: true,
                        message: "请选择",
                        trigger: ["blur", "change"],
                    },
                ],
            },
        };
    },
    created() {
        this.form.paymentMethod = this.permissionCode.has('research:product:price') ? 1 : 0;
    },
    methods: {
        ...mapActions("teachingCenter", ["saveProduct", "saveProductAutoUp"]),
        changeGroupPurchase(val) {
            if (val) {
                this.formData.allowable = 0;
            }
        },
        changeAllowAble(val) {
            if (val) {
                this.formData.groupPurchase = false;
                this.formData.allowable = 1;
            } else {
                this.formData.allowable = 0;
            }
        },
        clearForm() {
            this.formData = this.form;
        },
        sendPrice(val) {
            if (!val) {
                return null;
            } else {
                return val * 100;
            }
        },
        async handleConfirm() {
            this.blankWarning = this.inputValArr.length < 1;
            if (this.blankWarning) {
                this.$nextTick(() => {
                    const container = document.querySelector(".contentBox"); // 替换为你的滚动容器选择器
                    container.scrollTo(0, 200);
                });
                return;
            }
            await this.$refs.form.validate(async (valid) => {
                if (valid) {
                    let result = this.verifyMethod();
                    if (!result) {
                        return;
                    }
                    // this.formData.salePrice = this.sendPrice(this.formData.salePrice);
                    // this.formData.total = this.sendPrice(this.formData.total);
                    this.loadingSubmit = true;
                    try {
                        let groupPurchaseDataList = JSON.parse(
                            JSON.stringify(this.formData.groupPurchaseDataList)
                        );
                        if (this.formData.paymentMethod === 0) {
                            this.formData.total = null;
                            this.formData.salePrice = null;
                            groupPurchaseDataList = this.form.groupPurchaseDataList;
                        }
                        if (!this.formData.groupPurchase) {
                            groupPurchaseDataList = [];
                        } else {
                            groupPurchaseDataList.forEach((item) => {
                                item.salePrice = this.sendPrice(item.salePrice);
                            });
                        }
                        if (this.formData.allowable === 0) {
                            this.formData.discount = null;
                        }
                        await this.saveProduct({
                            ...this.formData,
                            total: this.sendPrice(this.formData.total),
                            salePrice: this.sendPrice(this.formData.salePrice),
                            buyOutPrice: this.sendPrice(this.formData.buyOutPrice),
                            groupPurchaseDataList: groupPurchaseDataList,
                        });
                        groupPurchaseDataList = null;
                    } finally {
                        this.loadingSubmit = false;
                    }
                    if (this.formData.id) {
                        this.$message.success("编辑成功");
                    } else {
                        this.$message.success("添加成功");
                    }
                    this.setData({key: "isBack", value: true});
                    this.$router.go(-1);
                }
            });
        },
        async handleSaveUp() {
            this.blankWarning = this.inputValArr.length < 1;
            if (this.blankWarning) {
                this.$nextTick(() => {
                    const container = document.querySelector(".contentBox"); // 替换为你的滚动容器选择器
                    container.scrollTo(0, 200);
                });
                return;
            }
            await this.$refs.form.validate(async (valid) => {
                if (valid) {
                    let result = this.verifyMethod();
                    if (!result) {
                        return;
                    }
                    // this.formData.salePrice = this.sendPrice(this.formData.salePrice);
                    // this.formData.total = this.sendPrice(this.formData.total);
                    this.loadingSubmit = true;
                    try {
                        let groupPurchaseDataList = JSON.parse(
                            JSON.stringify(this.formData.groupPurchaseDataList)
                        );
                        if (this.formData.paymentMethod === 0) {
                            this.formData.total = null;
                            this.formData.salePrice = null;
                            groupPurchaseDataList = this.form.groupPurchaseDataList;
                        }
                        if (!this.formData.groupPurchase) {
                            groupPurchaseDataList = [];
                        } else {
                            groupPurchaseDataList.forEach((item) => {
                                item.salePrice = this.sendPrice(item.salePrice);
                            });
                        }
                        if (this.formData.allowable === 0) {
                            this.formData.discount = null;
                        }
                        await this.saveProductAutoUp({
                            ...this.formData,
                            total: this.sendPrice(this.formData.total),
                            salePrice: this.sendPrice(this.formData.salePrice),
                            buyOutPrice: this.sendPrice(this.formData.buyOutPrice),
                            groupPurchaseDataList: groupPurchaseDataList,
                        });
                        groupPurchaseDataList = null;
                    } finally {
                        this.loadingSubmit = false;
                    }
                    if (this.formData.id) {
                        this.$message.success("发布成功");
                    } else {
                        this.$message.success("发布成功");
                    }
                    this.setData({key: "isBack", value: true});
                    this.$router.go(-1);
                }
            });
        },
        verifyMethod() {
            // 判断是否选择系列
            if (this.formData.productSubjects.length < 1) {
                this.$confirm("课包内系列数为0，请添加系列后重试!", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    closeOnClickModal: false,
                })
                    .then(async () => {
                        this.$nextTick(() => {
                            const container = document.querySelector(".contentBox"); // 替换为你的滚动容器选择器
                            container.scrollTo(0, 0);
                        });
                    })
                    .catch(() => {
                        const container = document.querySelector(".contentBox"); // 替换为你的滚动容器选择器
                        container.scrollTo(0, 0);
                    });
                return false;
            }
            // 判断语音是否跟文字一致
            // 判断是否要清空音频
            if (
                this.formData.introduce.materialUrl &&
                this.inputValArr.length < 1 &&
                this.formData.introduce.audioSsmlText !== ""
            ) {
                this.$confirm(
                    "你已对音频文字进行了删除操作,请选择是否要同步清除音频!",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                        closeOnClickModal: false,
                    }
                )
                    .then(async () => {
                        this.formData.introduce.audioText = "";
                        this.formData.introduce.audioSsmlText = "";
                        this.formData.introduce.materialUrl = "";
                        this.formData.introduce.filename = "";
                        this.formData.introduce.speechRate = 1.0;
                        this.formData.introduce.voice = "zhiyuan";
                    })
                    .catch(() => {
                        this.formData.introduce.audioSsmlText = "";
                    });
                return false;
            }
            let newAudioSsmlText = this.creatSsmlText(this.inputValArr);
            if (
                newAudioSsmlText !== this.formData.introduce.audioSsmlText &&
                this.inputValArr.length > 0
            ) {
                this.$confirm(
                    "你已对音频文字进行了修改,请确认是否重新生成音频!",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                        closeOnClickModal: false,
                    }
                )
                    .then(async () => {
                        await this.handleCreatAudio();
                    })
                    .catch(() => {
                        this.formData.introduce.audioSsmlText = newAudioSsmlText;
                    });
                return false;
            }
            newAudioSsmlText = null;
            return true;
        },
    },
};
